import { render, staticRenderFns } from "./SupportTicketDeleteButton.vue?vue&type=template&id=79fe9731&"
import script from "./SupportTicketDeleteButton.vue?vue&type=script&lang=js&"
export * from "./SupportTicketDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/domain/support_tickets/SupportTicketDeleteButton.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fdomain%2Fsupport_tickets%2FSupportTicketDeleteButton.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/i18n/form.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fdomain%2Fsupport_tickets%2FSupportTicketDeleteButton.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports